import { ReactNode } from "react";

export function ProfileItem(props: { title: string; children?: ReactNode }) {
  if (!props.children) {
    return null;
  }

  return (
    <div>
      <p className="text-body-4">{props.title}</p>
      <div className="text-body-3-medium">
        <strong>{props.children}</strong>
      </div>
    </div>
  );
}
